<template>
  <div>
    <v-dialog v-model="successDialog" max-width="320">
      <v-card>
        <v-card-title class="headline justify-center">
          {{ dialogTitle }}
        </v-card-title>
        <v-card-text>
          <p class="text-center">
            {{ dialogDescription }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="closeSuccessDialog">
            {{ $t('emailVerification.confirmButton') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="container">
      <div class="content text-center">
        <h1 class="text-h6">{{ $t('emailVerification.title') }}</h1>
        <div class="description-container">
          <p class="mb-0">
            {{ $t('emailVerification.confirmEmailMessage', {
              email_address: email
            }) }}
          </p>
        </div>
        <div class="button-container">
          <v-btn
            color="primary"
            block
            :disabled="loading"
            :loading="loading"
            @click="checkStatus"
          >
            {{ $t('emailVerification.checkAgain') }}
          </v-btn>
        </div>
        <div class="secondary-actions-container">
          <button
            class="secondary-action mb-3"
            @click="requestEmailVerification"
          >
            <span class="text-uppercase">
              {{ $t('emailVerification.emailNotReceived') }}
            </span>
            <span>{{ $t('emailVerification.sendEmailAgain') }}</span>
          </button>
          <button
            class="secondary-action text-uppercase"
            @click="logout"
          >
            {{ $t('auth.logout') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  data() {
    return {
      successDialog: false,
      loading: false,
      dialogTitle: '',
      dialogDescription: ''
    }
  },
  computed: {
    ...mapGetters(['user', 'isEmailVerificationRequired']),
    email() {
      return _.get(this.user, 'email')
    },
  },
  mounted() {
    this.setHideAppUI(true)
    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
  },
  beforeDestroy() {
    this.setHideAppUI(false)
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
  },
  methods: {
    ...mapMutations(['setHideAppUI']),
    ...mapActions(['userSignOut', 'verifyEmail', 'fetchUserProfile']),
    async checkStatus() {
      try {
        this.loading = true
        await this.fetchUserProfile()
        this.loading = false

        if (!this.isEmailVerificationRequired) {
          this.$router.push({name: 'home'})
        }
      } catch (error) {
        this.loading = false
      }
    },
    async requestEmailVerification() {
      try {
        await this.verifyEmail()
        this.dialogTitle = this.$t('emailVerification.emailSentTitle')
        this.dialogDescription = this.$t(
          'emailVerification.emailSentDescription',
          {
            email_address: this.email
          })
        this.successDialog = true
      } catch (error) {
        this.dialogTitle = this.$t('emailVerification.emailSentErrorTitle')
        this.dialogDescription = this.$t(
          'emailVerification.emailSentErrorDescription',
          {
            email_address: this.email
          })
        this.successDialog = true
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.checkStatus()
      }
    },
    closeSuccessDialog() {
      this.successDialog = false
    },
    logout() {
      this.userSignOut()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Viewport height - app layout padding - navbar height */
  min-height: calc(100vh - 66px - 51px - 56px);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 420px;
}

.description-container {
  padding: 12px 24px 0;
  margin: 0 auto;
}

.button-container {
  width: 100%;
  padding: 32px 0;
}

.secondary-actions-container {
  display: flex;
  flex-direction: column;
}

.secondary-action {
  span {
    display: block;
  }
}
</style>
